import React, { Component } from "react";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import * as appConst from "../../Common/constants";

class MedicineAdd extends Component {
  constructor(props) {
    super(props);

    var _name,
      _qty,
      _mode;
    if (this.props.pData._id === "NA") {
      _name = "";
      _qty = 0;
      _mode = "add";
    } else {
      _name = this.props.pData.name;
      _qty = this.props.pData.stock.main;
      _mode = "edit";
    }

    this.state = {
      name: _name,
      qty: _qty,
      mode: _mode,
      spinnerClass: "collapse",
      dataClass: ""
    };

  }

  render() {
    return (
      <div>
        <div>
          <h5 align="center"> {this.getHeading()}</h5>
        </div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Name</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Quantity</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.qty}
                  onChange={e => this.setState({ qty: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className={this.getCancelClass()}
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  getTxnDateClass() {
    let clsName = "row p-1 border ";
    if (this.props.pData._id !== "NA") clsName += "collapse";

    return clsName;
  }

  getHeading() {
    if (this.props.pData._id === "NA") return "Add Medicine";
    else return "Edit Medicine";
  }

  onSaveClick = e => {
    e.preventDefault();
    if (
      this.state.name === "" ||
      this.state.qty === 0
    ) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Mandatory Fields"
      });
    } else {
      const obj = {
        name: this.state.name,
        qty: this.state.qty
      };

      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +

            "/medicine/add",
            obj
          )
          .then(res =>
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: res.data
            })
          );
        this.ClearData();
      }
    }
  };

  ClearData() {
    this.setState({
      name: "",
      qty: 0,
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default MedicineAdd;
